import React from "react";
import './EventsListingCardSkeleton.css';

const EventsListingCardSkeleton = () => {
  return (
  <div className="event-card-container event-list-skeleton">
  <div className="event-card-image-wrapper event-list-shimmer-box image"></div>

  <div className="event-card-details">
    <div className="event-list-shimmer-box title"></div>

    <div className="event-card-meta">
      <div className="event-card-time-date">
        <div className="event-list-shimmer-box text small"></div>
        <div className="event-list-shimmer-box text small"></div>
      </div>
      <div className="event-card-rating">
        <div className="event-list-shimmer-box text small"></div>
      </div>
    </div>

    <div className="event-card-extra">
      <div className="event-card-type-price">
        <div className="event-list-shimmer-box text small"></div>
        <div className="event-list-shimmer-box text small"></div>
      </div>
      <div className="event-card-button">
        <div className="event-list-shimmer-box button"></div>
      </div>
    </div>
  </div>
</div>

  );
};

export default EventsListingCardSkeleton;
